/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetsTypeResource } from '../models/AssetsTypeResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AssetsTypeService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lister les types d'asset
     * Les types de contenus configurables (`name`, `description`, `type`, `format`) qui structurent les assets.
     * @returns AssetsTypeResource Array of `AssetsTypeResource`
     * @throws ApiError
     */
    public adminAssetstypeIndex(): CancelablePromise<Array<AssetsTypeResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/assetstype',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Creer un type d'asset
     * `name`, `description`, `type` et `format`.
     * @param requestBody
     * @returns AssetsTypeResource `AssetsTypeResource`
     * @throws ApiError
     */
    public adminAssetstypeStore(
        requestBody: {
            name: string;
            description: string;
            type: string;
            format: string | null;
        },
    ): CancelablePromise<AssetsTypeResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/assetstype',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un type d'asset
     * @param id
     * @returns AssetsTypeResource `AssetsTypeResource`
     * @throws ApiError
     */
    public adminAssetstypeShow(
        id: string,
    ): CancelablePromise<AssetsTypeResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/assetstype/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Modifier un type d'asset
     * Mise a jour partielle.
     * @param id
     * @param requestBody
     * @returns AssetsTypeResource `AssetsTypeResource`
     * @throws ApiError
     */
    public adminAssetstypeUpdate(
        id: string,
        requestBody?: {
            name?: string;
            description?: string;
            type?: string;
            format?: string | null;
        },
    ): CancelablePromise<AssetsTypeResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/admin/assetstype/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer un type d'asset
     * Refuse si des assets l'utilisent encore.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public adminAssetstypeDestroy(
        id: string,
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/assetstype/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
